import React from "react";
import { IconButton } from "@mui/material";
import AppLayout from "../../lib/components/Layout/app-layout";
import Header from "../../lib/components/Header";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import PreloaderTable from "../../lib/components/PreloaderTable";
import scrollHandler from "../../utils/scrollHandler";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import organizationservice from "../../service/organizationservice";
import DataTable from "../../lib/components/DataTable";

const OrganizationLogs = () => {
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const page = searchParams.get("page") || "1";
  const limit = searchParams.get("limit") || "20";

  const logsQuery = useQuery({
    retry: false,
    queryKey: ["organization-logs", page, limit],
    queryFn: () => organizationservice.getActivities({ page, limit }),
  });

  const { isPending, data } = logsQuery;
  const logsData = data?.data?.data;

  const columns = [
    {
      key: "notification",
      header: "Notifications",
      render: (_, row) => (
        <>
          <span className="fw-medium">{row?.replacers[0]?.name}</span>
          <span className="">
            {row?.text
              ?.replace("$1", "")
              .replace("$2", row?.replacers[1]?.name)
              .replace("$3", row?.replacers[2]?.name)
              .replace("$4", row?.replacers[3]?.name)}
          </span>
        </>
      ),
    },
    {
      key: "time",
      header: "Time",
      render: (_, row) => moment(row?.createdAt).fromNow(),
    },
  ];

  return (
    <AppLayout>
      <Header title="User Logs" description="" />
      <div className="p-3 bg-light" style={{ minHeight: "100%" }}>
        <IconButton
          className="bg-secondary-subtle mb-3"
          onClick={() => navigate(-1)}
        >
          <ArrowBack />
        </IconButton>

        <PreloaderTable isLoading={isPending} />
        <DataTable
          data={logsData}
          columns={columns}
          isLoading={isPending}
          page={Number(page)}
          pageSize={Number(limit)}
          totalPages={data?.data?.totalPages}
          onPageChange={(value) => handleChange(value, "page")}
          onPageSizeChange={(value) =>
            handleChange({ target: { value } }, "limit")
          }
        />
      </div>
    </AppLayout>
  );

  function handleChange(e, name = "") {
    const value = name.includes("date")
      ? moment(e).format("YYYY-MM-DD")
      : name === "page"
        ? e
        : e.target.value;
    searchParams.set(name, value);
    navigate(
      {
        pathname: window.location.pathname,
        search: searchParams.toString(),
      },
      { replace: true },
    );
    if (name === "page") scrollHandler();
  }
};

export default OrganizationLogs;
